import { Controller } from "@hotwired/stimulus"

// One tile turned over (#2041): the face shown and the face turned away. The
// turned-away face is inert, so neither a keyboard nor a screen reader lands
// on controls nobody can see. Closing hands focus back to whatever opened it,
// so a keyboard listener stays where they were on the card.
export default class extends Controller {
  static targets = ["front", "back"]

  declare readonly frontTarget: HTMLElement
  declare readonly backTarget: HTMLElement

  #opener: HTMLElement | null = null

  connect() {
    this.show(false)
  }

  get flipped(): boolean {
    return this.element.hasAttribute("data-flipped")
  }

  open() {
    if (this.flipped) return
    this.#opener =
      document.activeElement instanceof HTMLElement
        ? document.activeElement
        : null
    this.show(true)
    this.firstField()?.focus()
  }

  // data-action="keydown.esc->flip#close"
  close() {
    if (!this.flipped) return
    this.show(false)
    this.#opener?.focus()
    this.#opener = null
  }

  private show(flipped: boolean) {
    this.element.toggleAttribute("data-flipped", flipped)
    this.frontTarget.inert = flipped
    this.backTarget.inert = !flipped
    this.frontTarget.setAttribute("aria-hidden", String(flipped))
    this.backTarget.setAttribute("aria-hidden", String(!flipped))
  }

  // The field the listener came to fill, not the Close button above it.
  private firstField(): HTMLElement | undefined {
    return Array.from(
      this.backTarget.querySelectorAll<HTMLElement>("input"),
    ).find((field) => !field.closest("[hidden]"))
  }
}
